import React, { Component } from "react";
import "../../assets/css/custom.css";
import { serverResponse } from "../../util/fakeServer";
import { connect } from "react-redux";
import { isModalOpen } from "../../redux/carousel/action";
import Marker from "./markers/Marker";
import VideoInteractivity from "./videoInteractivity/VideoInteractivity";
import CustomPrice from "./CustomPrice";
var marker = serverResponse.config.marker
  ? serverResponse.config.marker
  : "circle_black";
const selected = require("assets/images/" + marker + ".svg");

class CustomProduct extends Component {
  state = {
    tooltipOpen: false
  };

  hasTooltip = () => {
    let result = this.props.info.type !== "product";
    let tooltip = this.props.info.markers[0].data.tooltip;

    return (
      result && tooltip !== "" && tooltip !== undefined && tooltip !== null
    );
  };

  render() {
    const styleProduct = {
      position: "absolute",
      display: this.props.info.blueprint !== null ? "flex" : "none",
      textAlign: "center",
      justifyContent: "center",
      alignItems: "center",
      top:
        this.props.info.blueprint !== null
          ? this.props.info.blueprint.top + "%"
          : "0%",
      left:
        this.props.info.blueprint !== null
          ? this.props.info.blueprint.left + "%"
          : "0%",
      width:
        this.props.info.blueprint !== null
          ? this.props.info.blueprint.width + "%"
          : "0%",
      height:
        this.props.info.blueprint !== null
          ? this.props.info.blueprint.height + "%"
          : "0%"
    };

    let markers = this.props.info.markers.map((element, index) => {
      if (
        this.props.info.type === "video" &&
        !this.props.info.markers[0].data.open_modal
      ) {
        return (
          <VideoInteractivity
            key={index}
            info={this.props.info}
            markerInfo={element}
            leafletSwipe={this.props.leafletSwipe}
            type={element.type}
          />
        );
      }
      return (
        <Marker
          // zoom={this.props.zoom}
          // disableSwipe={this.props.disableSwipe}
          // enableSwipe={this.props.enableSwipe}
          key={index}
          info={this.props.info}
          markerInfo={element}
          leafletSwipe={this.props.leafletSwipe}
          // navMarkers={this.navMarkers}
          // setSwipe={this.props.setSwipe}
          // isSwipeDisabed={this.props.isSwipeDisabed}
          type={element.type}
        />
      );
    });

    var id_select = "selected-" + this.props.info.item_id;
    var id_div = "div-" + this.props.info.item_id;

    return (
      <div
        data-type="customProduct"
        onMouseEnter={() => {
          this.setState({ tooltipOpen: true });
        }}
        onMouseLeave={() => {
          this.setState({ tooltipOpen: false });
        }}
        onClick={(e) => {
          if (e.target.dataset.type === "customProduct") {
            document
              .querySelector(
                `#${this.props.info.markers[0].type}-${this.props.info.item_id}`
              )
              .click();
          }
        }}
        title={""}
        id={id_div}
        className="customProduct"
        style={styleProduct}
      >
        {this.props.info.type === "product" && (
          <CustomPrice
            onClick={(e) => {
              document
                .querySelector(
                  `#${this.props.info.markers[0].type}-${this.props.info.item_id}`
                )
                .click();
            }}
            pageNumber={this.props.pageNumber}
            blueprint={this.props.info.blueprint}
            skul={this.props.info.skul}
            fontSizeServer={{
              desktop: serverResponse.config.price_text_size_d ? serverResponse.config.price_text_size_d : serverResponse.config.price_text_size,
              tablet: serverResponse.config.price_text_size_t ? serverResponse.config.price_text_size_t : serverResponse.config.price_text_size,
              mobile: serverResponse.config.price_text_size_m ? serverResponse.config.price_text_size_m : serverResponse.config.price_text_size
            }}
          />
        )}

        {serverResponse.config.marker_product_in_list &&
          this.props.cartReducer.cart.filter(
            (el) => el.skul === this.props.info.skul
          ).length > 0 && (
            <img
              src={selected}
              style={{
                position: "absolute",
                display: "block",
                width: "100%",
                height: "100%"
              }}
              alt="prodotto selezionato"
              id={id_select}
              onClick={() => document.getElementById(id_div).click()}
            />
          )}

        {markers}
        {this.state.tooltipOpen && this.hasTooltip() && (
          <div
            className="custom-tooltip"
            style={{
              fontSize: "12px",
              fontWeight: "bold",
              position: "absolute",
              top: "10%",
              backgroundColor: "var(--primary-color)",
              borderRadius: "0.25rem",
              padding: "0.25rem",
              color: "white"
            }}
          >
            <p>{this.props.info.markers[0].data.tooltip}</p>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    carouselIndex: state.carousel,
    modalRedux: state.modal,
    cartReducer: state.cartReducer
  };
};

export default connect(mapStateToProps, { isModalOpen })(CustomProduct);
